export const DEFAULT_MANDATORY_MSG = 'FRM_00001'
